import { render } from "./ApiClientIndex.vue?vue&type=template&id=760a96ba&scoped=true"
import script from "./ApiClientIndex.vue?vue&type=script&lang=js"
export * from "./ApiClientIndex.vue?vue&type=script&lang=js"

import "./ApiClientIndex.vue?vue&type=style&index=0&id=760a96ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-760a96ba"]])

export default __exports__